import React from 'react';
import { useParams } from 'react-router-dom';
import { MiniLoader } from '@pwc/pwc-deals-ui';
import UnableToLoadContent from 'features/analyses/common/UnableToLoadContent/UnableToLoadContent';
import { CommentTarget, CommentType } from '@pwc/pwc-deals-web-common';
import RichTextReadOnlyComment from '../../../components/RichTextForm/RichTextReadOnlyComment';
import './ContentItem.scss';

/**
 * Component usage: KFA in read-only mode
 */
const RichTextLibraryItem = ({ item }) => {
  const { projectId } = useParams();

  if (item.isLoading) {
    return (
      <div className="mini-loader-container">
        <MiniLoader />
      </div>
    );
  }
  if (item.hasError) {
    return (
      <UnableToLoadContent
        projectId={projectId}
        placeId="content-error-richTextLibraryItem"
      />
    );
  }

  return (
    <>
      <div className="rich-text-content-item-container css-override">
        <RichTextReadOnlyComment
          richText={item}
          libraryItemId={item.id}
          commentTarget={CommentTarget.LibraryItem}
          commentType={CommentType.RichText}
        />
      </div>
    </>
  );
};

export default React.memo(RichTextLibraryItem);
